/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RouteTypeEnum2 } from './routeTypeEnum2';
import { ServerTypeEnum } from './serverTypeEnum';
import { SmsApiServer } from './smsApiServer';


export interface SmsRouteModelOfSmsApiServer { 
    id: string;
    creatorId?: string;
    isOwnedByCoure: boolean;
    serverType: ServerTypeEnum;
    routeType: RouteTypeEnum2;
    operatorId: number;
    operatorCode?: string;
    routeCanBeUsedForMultipleOperators: boolean;
    publicName?: string;
    smsRouteName?: string;
    description?: string;
    rate: number;
    active: boolean;
    dateCreated: Date;
    smsRouteServer?: SmsApiServer;
    contentBasedRouteName?: string;
    isContentRetrievalRoute: boolean;
    countryId: number;
    networkCode?: string;
    routeTypeName?: string;
    country?: string;
    countryCode?: string;
    mnc?: string;
    mcc?: string;
}
